import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  departamentos: [],
  departamento: {},
  departamentoUse: {},
  operadores: [],
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
